
    const searchItems= [
        {
            "_id": "62a8ea0336110889521c1638",
            "image": "https://ak1.ostkcdn.com/images/products/30567641/Princess-Castle-Play-Tent-for-Girls-with-LED-Star-String-Lights-Pink-1-4678722b-257c-4bf6-bd2c-001768d22875_600.jpg?imwidth=480&impolicy=medium",
            "name": "Princess Castel LED Pink Tent",
            "price": 890,
            "assembly": "assembly required",
            "color": "Pink",
            "material": "net",
            "age": 2,
            "types": "Diy Kits",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8f9904bf9020488b98b93",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/e62c5f858340a249a2da1ee50b872dc496393358/Kaylee-Spindle-Chair-in-Fabric-with-White-Frame.jpg?imwidth=480&impolicy=medium",
            "name": "Chair",
            "price": 890,
            "assembly": "assembly required",
            "color": "gray",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8f9da4bf9020488b98b95",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/99409e2a1b7199dc06eae28d3957b282eb136145/Somette-Tucson-Full-Size-Futon-Set-in-Rustic-Walnut-Finish-with-Suede-Mattress.jpg?imwidth=480&impolicy=medium",
            "name": "Somette",
            "price": 896,
            "assembly": "assembly required",
            "color": "Black",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fa084bf9020488b98b97",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/08b80a67acf1c5ff748b98e4c070d2f09c789764/Carson-Carrington-Telsiai-Triangle-Wood-Coffee-Table.jpg?imwidth=480&impolicy=medium",
            "name": "Traingular table",
            "price": 233,
            "assembly": "assembly required",
            "color": "Black",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fa344bf9020488b98b99",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/b5d5a65eb6dd9de3411472ca72d2529047e09fa7/Silver-Orchid-Murray-Velvet-Upholstered-Accent-Chair.jpg?imwidth=480&impolicy=medium",
            "name": "Silver Accent Chair",
            "price": 2313,
            "assembly": "assembly required",
            "color": "Black",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fa664bf9020488b98b9b",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/0708f75c9e74e04c740cebda921185eaa91d3ebf/Upholstered-Tufted-Storage-Bench.jpg?imwidth=480&impolicy=medium",
            "name": "Upholtered Tufted Bench",
            "price": 513,
            "assembly": "assembly required",
            "color": "Black",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fa8d4bf9020488b98b9d",
            "image": "https://ak1.ostkcdn.com/images/products/15974793/Seaside-Hall-Tree-Distressed-White-1a6225df-6cbf-40b7-b590-83cdb55e3377_600.jpg?imwidth=480&impolicy=medium",
            "name": "Hall Tree",
            "price": 5513,
            "assembly": "assembly required",
            "color": "Black",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fae74bf9020488b98b9f",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/85a764db606f062300b9537089d3a4bbdd42e838/SAFAVIEH-Flokati-Shag-Mia-2.75-inch-Thick-Rug.jpg?imwidth=480&impolicy=medium",
            "name": "Carpet",
            "price": 6513,
            "assembly": "assembly required",
            "color": "Black",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fb0e4bf9020488b98ba1",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/150b0195a8339127379885c6d5b2160443af336f/SAFAVIEH-Orchard-Huberte-Distressed-Rug.jpg?imwidth=480&impolicy=medium",
            "name": "chair",
            "price": 6513,
            "assembly": "assembly required",
            "color": "Black",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fb3a4bf9020488b98ba3",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/fe77618ffa3521cd49edd506bd0a5e6c5b45e42e/SAFAVIEH-Vintage-Hamadan-Gody-Oriental-Distressed-Rug.jpg?imwidth=480&impolicy=medium",
            "name": "carpet",
            "price": 7513,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fb6a4bf9020488b98ba5",
            "image": "https://ak1.ostkcdn.com/img/mxc/03242022_SPRING2022_DECOR_PopCat_3.jpg?imwidth=400&impolicy=medium",
            "name": "curtain",
            "price": 8513,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fb8c4bf9020488b98ba7",
            "image": "https://ak1.ostkcdn.com/img/mxc/03242022_SPRING2022_DECOR_PopCat_4.jpg?imwidth=400&impolicy=medium",
            "name": "wall art",
            "price": 813,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fbbc4bf9020488b98ba9",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/432d8e18b2649f81fab8c7f80687d46907925149/ArtWall-Cora-Niele-%27White-Tulip%27-Gallery-Wrapped-Canvas-Wall-Art.jpg?imwidth=480&impolicy=medium",
            "name": "wall art",
            "price": 2813,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fbe64bf9020488b98bab",
            "image": "https://ak1.ostkcdn.com/images/products/16373111/Wexford-Home-Twilight-Romance-Gallery-wrapped-Canvas-2e742367-426c-42d9-bfed-1ea4b0c2938b_600.jpg?imwidth=480&impolicy=medium",
            "name": "home Twilight",
            "price": 9813,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fc254bf9020488b98bad",
            "image": "https://ak1.ostkcdn.com/images/products/7396575/VanGogh-Dasies-and-Poppies-Wrapped-Canvas-Red-Green-ba819c05-39a0-473b-9e43-66bea691d754_600.jpg?imwidth=480&impolicy=medium",
            "name": "vincent",
            "price": 4342,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fc7b4bf9020488b98baf",
            "image": "https://ak1.ostkcdn.com/img/mxc/05122022_BEDDING_219x219_shop_more01_beddingsets.jpg?imwidth=200&impolicy=medium",
            "name": "bedsheet",
            "price": 432,
            "assembly": "assembly required",
            "color": "white",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fc964bf9020488b98bb1",
            "image": "https://ak1.ostkcdn.com/img/mxc/05122022_BEDDING_219x219_shop_more06_bedprotectors.jpg?imwidth=200&impolicy=medium",
            "name": "bedsheet",
            "price": 9432,
            "assembly": "assembly required",
            "color": "white",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fcbd4bf9020488b98bb3",
            "image": "https://ak1.ostkcdn.com/img/mxc/05122022_BEDDING_219x219_shop_more12_pillowshams.jpg?imwidth=200&impolicy=medium",
            "name": "pillow",
            "price": 341,
            "assembly": "assembly required",
            "color": "white",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fcd74bf9020488b98bb5",
            "image": "https://ak1.ostkcdn.com/img/mxc/05122022_BEDDING_219x219_shop_more01_beddingsets.jpg?imwidth=200&impolicy=medium",
            "name": "pillow",
            "price": 341,
            "assembly": "assembly required",
            "color": "white",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fd0b4bf9020488b98bb7",
            "image": "https://ak1.ostkcdn.com/img/mxc/03232020-gnp-homeimprovment-PopCat_10.jpg?imwidth=400&impolicy=medium",
            "name": "shower",
            "price": 641,
            "assembly": "assembly required",
            "color": "white",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fd334bf9020488b98bb9",
            "image": "https://ak1.ostkcdn.com/img/mxc/02182021-gnp-homeimprovement-bathroom-PopCat_7.jpg?imwidth=400&impolicy=medium",
            "name": "faucets",
            "price": 641,
            "assembly": "assembly required",
            "color": "white",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fd5f4bf9020488b98bbb",
            "image": "https://ak1.ostkcdn.com/img/mxc/02182021-gnp-homeimprovement-home-PopCat_1.jpg?imwidth=400&impolicy=medium",
            "name": "lightning ceiling fans",
            "price": 871,
            "assembly": "assembly required",
            "color": "white",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fdae4bf9020488b98bbd",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/26e92f086c8dd18e9207e123d2eb906a00c56bb3/Panbado-Bone-China-Floral-Decals-Tea-Cup-with-Saucer-Spoon.jpg?imwidth=480&impolicy=medium",
            "name": "panbado tea cup",
            "price": 2871,
            "assembly": "assembly required",
            "color": "white",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fde24bf9020488b98bbf",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/f713117711f12d7be38424246ee37e01f82b16f9/Hibiscus-4-Piece-Place-Setting.jpg?imwidth=480&impolicy=medium",
            "name": "hibiscus 4-piece place setting",
            "price": 2871,
            "assembly": "assembly required",
            "color": "blue",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fe1a4bf9020488b98bc1",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/43ee41bfdddab4d55dd1cd8226dbf36440300cf1/vancasso-Navia-Stoneware-8-inch-Soup-Bowl-Dinnerware-Set-24-Oz..jpg?imwidth=480&impolicy=medium",
            "name": "pasta bowl",
            "price": 9871,
            "assembly": "assembly required",
            "color": "blue",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fe574bf9020488b98bc3",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/07b8779fa5b48a4f7ab7ecd716fc4dbf8af0b39f/vancasso-Carpi-Mini-Casserole-with-Lids%2C-Starry-Blue-%28Set-of-4%29.jpg?imwidth=480&impolicy=medium",
            "name": "vancasso carpi",
            "price": 2871,
            "assembly": "assembly required",
            "color": "blue",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8feaa4bf9020488b98bc5",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/cafac9c36f02dee4290627fdbb41990c8d48ef51/Olive-Wood-8-Piece-Wooden-Kitchen-Tool-Set.jpg?imwidth=480&impolicy=medium",
            "name": "olive wood tool",
            "price": 281,
            "assembly": "assembly required",
            "color": "blue",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fece4bf9020488b98bc7",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/f5b2e9d1476736b6085e7943106695196b9c13d4/Kuhn-Rikon-2-Cup-Pull-%26-Chop-Food-Chopper-Model-K50212.jpg?imwidth=480&impolicy=medium",
            "name": "chop",
            "price": 281,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8ff2a4bf9020488b98bc9",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/c206a6e24c9d1ab0cac54cd09e78213107cdccfd/Abalone-Glass-Pendant-Light-by-Hampton-Hill.jpg?imwidth=480&impolicy=medium",
            "name": "glass pendant light",
            "price": 5281,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8ff534bf9020488b98bcb",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/6de3cd69bd8bf2986a4cc918e8759b72273077c5/Sigrid-River-of-Goods-Antique-Bronze-Metal-Bowl-Shade-Pendant-Lamp.jpg?imwidth=480&impolicy=medium",
            "name": "antique bronze lamp",
            "price": 2281,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8ff7f4bf9020488b98bcd",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/842459fb0c5930fb4b5e665756fadf008344032a/Moonrise-12-Inch-Modern-Opaque-Glass-Pendant-Ceiling-Light.jpg?imwidth=480&impolicy=medium",
            "name": "decanter seeded",
            "price": 481,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8ffb84bf9020488b98bcf",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/26ca43f5da9eec1b4f4e2d5747dafec0504964ae/Farmhouse-3-Light-Lantern-Chandelier-Rustic-Wood-Foyer-Pendant-Light.jpg?imwidth=480&impolicy=medium",
            "name": "farmhouse light",
            "price": 4781,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a8fff64bf9020488b98bd1",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/4869215a5ea8bc6302fe309c8ff9405b27c987e4/Respawn-110-Racing-Style-Reclining-Gaming-Chair-with-Footrest.jpg?imwidth=480&impolicy=medium",
            "name": "racing style chair",
            "price": 7881,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a9001a4bf9020488b98bd3",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/1100619efe44a2adbb065014895b018f494ffcc6/Caynel-4-Liter-Portable-Mini-Fridge-for-Home%2C-Office-and-Car%2C-AC-DC-Thermoelectric-System.jpg?imwidth=480&impolicy=medium",
            "name": "mini fridge",
            "price": 5081,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a9003d4bf9020488b98bd5",
            "image": "https://ak1.ostkcdn.com/images/products/8815072/Ninja-BL610-Black-1000-watt-Professional-Blender-5245aceb-067c-45bf-9587-8413f4ce204e_600.jpg?imwidth=480&impolicy=medium",
            "name": "jucer",
            "price": 1081,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a9008e4bf9020488b98bd8",
            "image": "https://ak1.ostkcdn.com/images/products/21030372/JoyJolt-Carre-Square-Whiskey-Glasses-10-Oz-Set-of-2-Old-Fashioned-Glasses-9e833c60-8426-4ddd-8b0c-abdf442f2d09_600.jpg?imwidth=480&impolicy=medium",
            "name": "joy jolt",
            "price": 681,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a901254c3eb6ccbd86d3ef",
            "image": "https://ak1.ostkcdn.com/images/products/is/images/direct/329d749eb5c4bd67784b5be18bc236332bb60e0e/FizzPod-One-Touch-Home-Sparking-Soda-Maker-Machine-with-3-Bottles.jpg?imwidth=480&impolicy=medium",
            "name": "touch home",
            "price": 681,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        },
        {
            "_id": "62a9014c4c3eb6ccbd86d3f1",
            "image": "https://ak1.ostkcdn.com/images/products/15907675/Hey-Play-Giant-Wooden-Yard-Dice-Outdoor-Lawn-Game-e75a72c4-3d79-41e9-9e9c-6ca99bf99c43_600.jpg?imwidth=480&impolicy=medium",
            "name": "dice",
            "price": 681,
            "assembly": "assembly required",
            "color": "red",
            "material": "cotton",
            "age": 2,
            "types": "",
            "brands": "KidKraft",
            "features": "Indoor",
            "availabilty": "available",
            "updatedAt": "2022-06-14T20:05:23.573Z",
            "createdAt": "2022-06-14T20:05:23.573Z"
        }
    ]

    export default searchItems